export function FormError({ error }: { error: string }) {
  return <p className="pt-1 text-xs text-red-500">{error}</p>;
}
